// extracted by mini-css-extract-plugin
export var container = "EmbededReviews-module--container--98e24";
export var reviews = "EmbededReviews-module--reviews--c4f30";
export var section = "EmbededReviews-module--section--884a6";